// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fPoDX","label":"styles_label__m17IG"};